import { ComponentType, lazy, LazyExoticComponent } from "react";
import { importWithRetry, markMissingExport } from "src/lib/chunk-retry";

export function lazyNamed<T extends Record<string, any>>(
  factory: () => Promise<T>,
  name: keyof T & string,
) {
  return lazy(() =>
    importWithRetry(factory).then((m) => {
      if (!m[name]) {
        // Deliberately mimics the Chrome chunk-load message so it groups with
        // chunk errors in Sentry; the structural marker keeps the retry
        // ladder from re-fetching what is a build-shape bug, not a network one.
        throw markMissingExport(
          new Error(
            `Failed to fetch dynamically imported module: export '${name}' resolved to ${typeof m[name]}`,
          ),
        );
      }
      return { default: m[name] };
    }),
  );
}

/** `React.lazy` with the chunk-retry ladder, for default-export modules. */
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
): LazyExoticComponent<T> {
  return lazy(() => importWithRetry(factory));
}
